import { getBaseURL } from '../Helpers/utils';
import { BlogOverviewResult } from './types';

export type OverviewRequest = {
    rootId: number;
    categoryKey: string;
    authors: string[];
    types: string[];
    page: number;
    pageSize: number;
};

/**
 * GET /api/blog/overview. Not the shared fetchAPI helper: that one cannot be cancelled and treats an
 * error status as data. A filter change has to abort the request it replaces, or a slow earlier
 * response could land after the newer one and overwrite it.
 */
export async function fetchOverviewPage(request: OverviewRequest, signal: AbortSignal): Promise<BlogOverviewResult> {
    const params = new URLSearchParams();
    params.set('root', String(request.rootId));
    params.set('category', request.categoryKey);
    if (request.authors.length > 0) {
        params.set('authors', request.authors.join(','));
    }
    if (request.types.length > 0) {
        params.set('types', request.types.join(','));
    }
    params.set('page', String(request.page));
    params.set('pageSize', String(request.pageSize));

    const response = await fetch(`${getBaseURL()}/api/blog/overview?${params.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal,
    });
    if (!response.ok) {
        throw new Error(`Blog overview request failed with status ${response.status}.`);
    }

    const body = (await response.json()) as BlogOverviewResult;
    if (!body || !Array.isArray(body.items)) {
        throw new Error('Blog overview response was not in the expected shape.');
    }
    return body;
}

export function isAbort(error: unknown): boolean {
    return error instanceof DOMException && error.name === 'AbortError';
}
